module.exports = __webpack_public_path__ + "img/tools_relocation_calculator2.c1483bae.png";